export function departureForStep(stops, step) {
  return (stops || []).find((stop) => stop.truck_id === step?.truck_id && stop.step_ids.includes(step?.step_id)) || null;
}

export function departureForGroup(stops, group) {
  const first = departureForStep(stops, group?.steps?.[0]);
  return first && group.steps.every((step) => departureForStep(stops, step) === first) ? first : null;
}

export function departureClock(stop) {
  return new Intl.DateTimeFormat("fr-CA", { timeZone: stop.timezone || "America/Toronto", hour: "2-digit", minute: "2-digit" }).format(new Date(stop.departure));
}
